import React from 'react';
import { animated, useSpring } from 'react-spring';

import Icon from 'components/icon/icon';
import { TextProps } from 'components/typography/text';

type FaqAccordionProps = {
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  as?: TextProps['as'];
  extraClass?: string;
};

const FaqAccordion: React.FC<FaqAccordionProps> = (props) => {
  const [isContentVisible, setIsContentVisible] = React.useState(false);
  const { rotation } = useSpring({
    rotation: !isContentVisible ? 45 : 0,
    config: { tension: 300, friction: 10 },
  });

  const handleTitleClick = () => {
    setIsContentVisible(!isContentVisible);
  };

  return (
    <section className={`accordion${props.extraClass ? ` ${props.extraClass}` : ''}`}>
      <button className="accordion__header" onClick={handleTitleClick} aria-label="open-faq-button">
        <span className="accordion__title">{props.title}</span>
        <span className="accordion__close">
          {/* @ts-ignore */}
          <animated.div
            style={{
              transform: rotation.to((degrees) => `rotate(${degrees}deg)`),
            }}
          >
            <Icon name="icon-close" size="md" />
            {/* @ts-ignore */}
          </animated.div>
        </span>
      </button>

      {isContentVisible ? <div className="accordion__content">{props.content}</div> : null}
    </section>
  );
};

export default FaqAccordion;
